import { render } from "./expertItem.vue?vue&type=template&id=14b1e48e&scoped=true"
import script from "./expertItem.vue?vue&type=script&lang=js"
export * from "./expertItem.vue?vue&type=script&lang=js"

import "./expertItem.vue?vue&type=style&index=0&id=14b1e48e&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\gaoxinTech\\gaoxin_tech1\\gaoxintech\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b1e48e"]])

export default __exports__